import { useQuery } from "@tanstack/react-query";
import { ExhibitionsApi } from "../services";
import { ShortExhibition } from "../models/shortExhibition";
import { Link } from "react-router-dom";

export const Exhibitions = () => {
    const { data: exhibitionsData, error, isLoading } = useQuery<ShortExhibition[]>({
        queryKey: ["exhibitions"],
        queryFn: ExhibitionsApi.getExhibitionsShort,
    });
    const exhibitions = exhibitionsData ?? [];

    if (isLoading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error loading exhibitions</div>;
    }

    if (!exhibitions) {
        return <div></div>
    }

    if (!Array.isArray(exhibitions)) {
        return <div>Data nejsou v požadovaném formátu.</div>;
    }

    return (
        <div className="flex flex-col space-y-5 pb-5">
            <div className="flex flex-col relative bg-[url('../public/cats/Mendeleev_Monoid_CZ.jpg')] bg-cover bg-center p-20 bg-fixed">
                <div className="absolute inset-0 bg-black opacity-65"></div>
                <div className="flex flex-col text-center">
                    <div className="text-white z-10 text-5xl">
                        Výstavy
                    </div>
                </div>
            </div>
            <div className="flex flex-col px-5 w-full md:w-2/3 mx-auto space-y-5">
                {
                    exhibitions?.map((exhibition, key) => (
                        <ShortExhibitionItem exhibition={exhibition} key={key} />
                    ))
                }
            </div>
        </div>
    )
}

interface ShortExhibitionProps {
    exhibition: ShortExhibition
}

export const ShortExhibitionItem: React.FC<ShortExhibitionProps> = ({ exhibition }) => {
    const date = new Date(exhibition.date);

    return (
        <Link to={`/exhibitions/${exhibition.exhibitionId}`}>
            <div className="flex flex-col md:flex-row bg-[#333333] justify-between p-3 items-center">
                <div className="text-center md:text-left text-white text-lg md:text-xl lg:text-2xl">
                    {exhibition.name}
                </div>
                <div>
                    <div className="text-white text-center md:text-right text-sm md:text-lg">
                        {exhibition.location}
                    </div>
                    <div className="text-white text-center md:text-right text-sm md:text-lg">
                        {date.getDate() + "." + date.getMonth() + "." + date.getFullYear()}
                    </div>
                </div>
            </div>
        </Link>
    )
}
